module.exports = __webpack_public_path__ + "static/media/master.7de5e5f7.svg";